import React, { FC } from 'react'
import { Svg, Path } from './Icon.styles'
import { IconProps } from './types'
import icons, { size, IconType } from '../icons'

const Icon: FC<IconProps> = props => {
  const { name, color } = props
  const data: IconType = icons?.[name as keyof typeof icons]
  const viewportSize: number = size?.[props.size as keyof typeof size]

  return (
    <Svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox={data?.viewBox}
      width={viewportSize}
      height={viewportSize}
      hoverColor={props.hoverColor}
      color={props.color}
      aria-label={name}
      onClick={props.clickFunction}
      onKeyDown={props.keyDownFunction}
      tabIndex={0}
      cursor={props.clickFunction ? 'pointer' : 'inherit'}
      svgMargin={props.svgMargin}
      backgroundColor={props.backgroundColor}
    >
      <Path d={data?.path} color={color} />
    </Svg>
  )
}

Icon.defaultProps = {
  size: 'xs',
  hoverColor: false,
}

export default Icon
